import React from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";

const ExportPDF = ({ data, rep_t }) => {
  function exportPDF() {
    const base64Img =
      "data:image/png;base64,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";

    const unit = "pt";
    const size = "b4"; // Use A1, A2, A3 or A4
    const orientation = "landscape";

    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(10);

    var headers;
    var data1;

    switch (rep_t) {
      case 1:
        headers = [
          [
            "Registrado",
            "Nombre",
            "C.I",
            "Correo",
            "Teléfono",
            "Aliado Comercial",
            "Plan Solicitado",
            "MDT",
            "Estatus MDT",
            "NAP",
            "Distancia NAP",
            "OLT",
            "Coordenadas"
          ],
        ];

        data1 = data.map((elt) => [
          elt.REGISTRADO,
          elt.NOMBRE,
          elt.CI_RIF,
          elt.CORREO,
          elt.TELEFONO,
          elt.MDT_AC,
          elt.PLAN_SOLICITADO,
          elt.MDT,
          elt.ESTATUS_MDT,
          elt.NAP,
          elt.DISTANCIA_NAP,
          elt.NODO,
          elt.UBICACION_CP,
        ]);
        break;
      case 2:
        headers = [
          [
            "Fecha de Asignación",
            "Aliado Comercial",
            "Aliado Comercial Reasignado",
            "Última Actualización",
            "Realizado Por",
            "OLT",
            "MDT",
            "Estatus",
          ],
        ];

        data1 = data.map((elt) => [
          elt.FechaInstalacion,
          elt.Ac,
          elt.Reasignado_Ac,
          elt.FechaReasignacion,
          elt.UserReasignacion,
          elt.Nodo,
          elt.Nombre_mdt,
          elt.Estado,
        ]);

        break;

      case 3:
        headers = [
          [
            "Aliado Comercial",
            "CI / RIF",
            "Representante",
            "Instagram",
            "Correo",
            "Teléfono",
            "Dirección",
          ],
        ];

        data1 = data.map((elt) => [
          elt.descripcion,
          elt.rif,
          elt.representante,
          elt.instagram,
          elt.email,
          elt.telefono,
          elt.direccion,
        ]);

        break;

      case 4:
        headers = [
          [
            "Registrado",
            "Nombre",
            "CI / RIF",
            "Teléfono",
            "Correo",
            "Plan Solicitado",
            "MDT",
            "NAP",
            "Estatus NAP",
            "Aliado Asignado",
            "Promotor",
            "Fecha de Asignación",
          ],
        ];


        data1 = data.map((elt) => [
          elt.REGISTRADO,
          elt.NOMBRE,
          elt.CI_RIF,
          elt.TELEFONO,
          elt.CORREO,
          elt.PLAN_SOLICITADO,
          elt.MDT,
          elt.NAP,
          elt.ESTATUS_NAP,
          elt.CLIENTE_ASIG_AC,
          elt.PROMOTOR,
          elt.FCH_ASIG_CLIENTE_AC,
        ]);

        break;

      default:
        headers = [
          [
            "Registrado",
            "Nombre",
            "C.I",
            "Correo",
            "Teléfono",
            "Aliado Comercial",
            "Plan Solicitado",
            "MDT",
            "Estatus MDT",
            "NAP",
            "Distancia NAP",
            "OLT",
          ],
        ];

        data1 = data.map((elt) => [
          elt.REGISTRADO,
          elt.NOMBRE,
          elt.CI_RIF,
          elt.CORREO,
          elt.TELEFONO,
          elt.MDT_AC,
          elt.PLAN_SOLICITADO,
          elt.MDT,
          elt.ESTATUS_MDT,
          elt.NAP,
          elt.DISTANCIA_NAP,
          elt.NODO,
        ]);
        break;
    }

    let content = {
      startY: 80,
      head: headers,
      showHead: "everyPage",
      body: data1,
      didDrawPage: function (data) {
        // Header
        data.settings.margin.top = 70;
        doc.setFontSize(12);
        doc.setTextColor(40);

        if (base64Img) {
          doc.addImage(
            base64Img,
            "JPEG",
            data.settings.margin.left,
            15,
            180,
            25
          );
        }

        doc.text(
          rep_t === 1
            ? "Reporte Clientes Potenciales"
            : rep_t === 2
            ? "Reporte Asignación MDT"
            : rep_t === 3
            ? "Reporte Aliados Comerciales"
            : "Reporte Clientes Asignados",
          250,
          31
        );
        doc.setFont("courier");
        doc.setFontSize(10);
      },

      headStyles: { fillColor: [17, 17, 17], halign: "center" },

      styles: {
        fontSize: 7,
        margin: 0,
        minCellHeight: 3,
        minCellWidth: 4,
        halign: "center",
        cellWidth: "auto",
        overflow: "linebreak",
      },
    };

    doc.autoTable(content);
    doc.save(
      rep_t === 1
        ? "Reporte Clientes Potenciales"
        : rep_t === 2
        ? "Reporte Asignación MDT"
        : rep_t === 3
        ? "Reporte Aliados Comerciales"
        : "Reporte Clientes Asignados"
    );
  }

  return (
    <div>
      <button className="dropdown-item" onClick={exportPDF}>
        PDF
      </button>
    </div>
  );
};

export default ExportPDF;
